import initSliders from "../components/initSliders.js";
import initTabs from "../components/initTabs.js";

document.addEventListener("DOMContentLoaded", () => {

    const {
        initHeroSlider,
        initSponsorsSlider
    } = initSliders();

    initHeroSlider();
    initSponsorsSlider();

    initTabs();

});
